import { getRegisterFunction } from '../../utils/register.js';
import { OneUxDropdownElement } from './OneUxDropdownElement.js';
export const register = getRegisterFunction(OneUxDropdownElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-dropdown': OneUxDropdownElement;
    "dropdown-31172601af8985a89a577f1a853a1fba": OneUxDropdownElement;
  }
}